(function () {
	"use strict";

	angular.module("swurveys.maker")
		.controller("analyticsController", Handler)


		function Handler($scope, $http, $interval, $window, $location, $routeParams, utilsService, ModalService, analyticsService, swurveyService, swurveyAdminService, swurveysStageConfig, liveReloadService, loggedInUser) {


			if($routeParams.cardId)
			{
				$scope.cardId = $routeParams.cardId.split(",");
			}
			$scope.swurveyId = $routeParams.sid;

			function reloadStyles(stylesList) {
				var freeStyle = $("style#free-style")[0].sheet;

				utilsService.cleanUpStyle(freeStyle, false);

				stylesList.forEach(function (style) {
					var index = freeStyle.cssRules.length;
					freeStyle.insertRule(style, index);
				});
			};

			function stripHTML(html) {
				var tmp = document.createElement("DIV");
				tmp.innerHTML = html;
				return tmp.textContent || tmp.innerText || "";
			}


			var percentLegend = "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=segments.length - 1; i >= 0; i--)" +
				"{%>" +
				"<li>" +
				"<span style=\"background-color:<%=segments[i].fillColor%>\"></span>" +
				"<%" +
				"if(segments[i].label){" +
				"%> <%=segments[i].label%>: <%" +
				"}%>" +
				"<%=segments[i].value%>%<%" +
				"}%>" +
				"</li>" +
				"</ul>";

			var rawNumberLegend = "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=segments.length - 1; i >= 0; i--)" +
				"{%>" +
				"<li>" +
				"<span style=\"background-color:<%=segments[i].fillColor%>\"></span>" +
				"<%" +
				"if(segments[i].label){" +
				"%> <%=segments[i].label%>: <%" +
				"}%>" +
				"<%=segments[i].value%><%" +
				"}%>" +
				"</li>" +
				"</ul>";

			//Global color configuration for Angular Charts
			Chart.defaults.global.colours = ["#55D6BE", "#136F63", "#2980b9", "#63D2FF", "#4F6D7A"];
			Chart.defaults.global.scaleBeginAtZero =false;
			


			//Options for all pie charts
			$scope.pieOptions = {
				responsive: true,
				maintainAspectRatio: true,
				tooltipTemplate: "<%=label%>: <%= value %>%",
				//String - A legend template
				legendTemplate: percentLegend

			};

			//Options for all bar charts
			$scope.barOptions = {
				responsive: true,
				maintainAspectRatio: true,
				tooltipTemplate: "<%=label%>: <%= value %>%"
			};

			//Important fields
			var	swurveID = $routeParams.sid;
			var credential = loggedInUser;
			var autoReloadInterval;
			$scope.user = loggedInUser.user;
			$scope.totalResponses = -1;
			$scope.swurveName = "";
			$scope.cards = {};
			$scope.publicData = $routeParams.dataType === "public";
			$scope.percentView = true;
			if($scope.publicData)
			{
				analyticsService.trackEvent('ViewPublicData', swurveID);
			}
			else
			{
				analyticsService.trackEvent('ViewPrivateData', swurveID);
			}

			/**
			 * Hides all graph views
			 */
			$scope.showAll = function () {
				for(var card in $scope.cards) {
					if($scope.cards.hasOwnProperty(card)) {
						$scope.cards[card].visible = true;
					}
				}
			};

			/**
			 * Shows all graph views
			 */
			$scope.hideAll = function () {
				for(var card in $scope.cards) {
					if($scope.cards.hasOwnProperty(card)) {
						$scope.cards[card].visible = false;
					}
				}
			};

			$scope.toggleExpandAll = function() {
				if($scope.allExpanded)
				{
					$scope.hideAll();
					$scope.allExpanded = false;
				}
				else
				{
					$scope.showAll();
					$scope.allExpanded = true;
				}

			};

			$scope.togglePercent = function() {
				$scope.percentView = !$scope.percentView;
			};

            $scope.$watch("percentView", function(percentView) {
            	updateDataView();
            });
            var updateDataView = function() {

				var cards = $scope.cards;
            	if(!$scope.percentView)
            	{
					for (var card in cards) {

						// Convert card data
						if(cards.hasOwnProperty(card)) {

							// Convert top answer percent
							 cards[card].topAnswerData = cards[card].topAnswerDataRaw;

							for (var x = 0; x < $scope.cards[card].data.length; x++) {
								cards[card].data[x] = cards[card].rawData[x];
							}
						}
					}

					// Remove percentages
					$scope.pieOptions.tooltipTemplate = '<%=label%>: <%= value %>';
					$scope.pieOptions.legendTemplate = rawNumberLegend;

					$scope.barOptions.tooltipTemplate = '<%=label%>: <%= value %>';

            	}
            	else{

					for (var card in cards) {

						// Convert card data
						if (cards.hasOwnProperty(card)) {
							//The number of responses to a card.
							//This should be equal to scope.totalResponses..unless you're using branching
							var responseCount = cards[card].rawData.reduce(function (a, b) { return a + b; });

							//Just some (in)consistency checking.
							if ($scope.model.options && $scope.model.options.branching && !$scope.model.options.branching.enabled) {
								if (responseCount != $scope.totalResponses) {
									console.error("Inconsistent data!. Look like this card doesn't have all its responses and branching is not enabled", swurveID, card);
								}
							}
							cards[card].responseCount = responseCount;

							// Convert top answer percent
							cards[card].topAnswerData = getAsPercent(cards[card].topAnswerDataRaw, responseCount);

							for (var x = 0; x < $scope.cards[card].data.length; x++) {
								cards[card].data[x] = getAsPercent(cards[card].rawData[x], responseCount);
							}
						}
					}

					// Remove percentages
					$scope.pieOptions.tooltipTemplate = '<%=label%>: <%= value %>%';
					$scope.pieOptions.legendTemplate = percentLegend;

					$scope.barOptions.tooltipTemplate = '<%=label%>: <%= value %>%';

            	}

            };


			/**
			 * Retrieves the model for a given ID
			 * @param id Swurvey ID
			 */
			var loadSwurvey = function (id) {
				swurveyService.getModel(id, function (err, res) {
					if(err) {

  				        $location.path("/error").search({message :"Sorry, this Swurvey does not exist"});

						return console.log(err);
					}
					var model = res.data;
					$scope.model = model;


					//HACK: Populate $scope.cards
					for(var i = 0; i < model.cards.length; i++) {
						var card = model.cards[i];

						//Remove html tags
						card.text = stripHTML(card.text);



						if(utilsService.getQuestionCardTypes().indexOf(card.type) > -1) {

							//Add card to card map
							$scope.cards[card.id] = card;

							$scope.cards[card.id].visible = false;

							//Add chartType property
							if($scope.cards[card.id].type !== "slider") {
								$scope.cards[card.id].chartType = "pie";
							} else {
								$scope.cards[card.id].chartType = "bar";
							}
						}
					}
					$scope.url = res.headers("x-swv-short-url");
					$scope.ownerId = res.headers("x-swv-owner");
					var userId = $scope.ownerId.split("user:")[1];
                    
					if($routeParams.dataType == "billboard")
					{
						$scope.percentView = false;
						Chart.defaults.global.scaleFontColor = "white";
						Chart.defaults.global.scaleFontSize = "22.5";
						Chart.defaults.global.scaleFontFamily = "arial";
						Chart.defaults.global.colours = ["#27ccc0"];
						$scope.barOptions.maintainAspectRatio = false;
						//$scope.barOptions.responsive = false;
						$scope.card = $scope.cards[$scope.cardId[0]];
						$scope.billboard = {
							overrides : {
								logo: "https://www.swurveys.com/wp-content/uploads/2016/01/swurve_logo_light-1.png",
								bgmp4 : "https://app.swurveys.com/assets/us-east-1:6d5e840a-78c9-4187-ad4a-ced426e42ac6/Ada1a719-66c9-4eef-ad04-babdbd61166f",
								CTA :  "TO CAST YOUR VOTE!",
								swurveysLogo : "https://www.swurveys.com/wp-content/uploads/2016/01/swurve_logo_light-1.png"
							}
						}
                        if($scope.cardId.length > 1)
						{
							//If we have more than 1 cardId, then let's flip through them every 15 seconds
							var currentCardIndex = 1;
							$interval(function(){
							  $scope.card = $scope.cards[$scope.cardId[currentCardIndex]];
							  currentCardIndex = currentCardIndex + 1;
							  if(currentCardIndex == $scope.cardId.length)
							  {
								  currentCardIndex = 0;
							  }
						  }, 15000);
						}
						if(model.billboard)
						{
							angular.extend($scope.billboard.overrides, model.billboard.overrides);
							angular.extend(Chart.defaults.global, model.billboard.chartGlobal);
							if(model.billboard.styles)
							{
								reloadStyles(model.billboard.styles);
							}
							if(model.billboard.graphColors)
							{
								Chart.defaults.global.colours = model.billboard.graphColors;
							}
					    }

						var credentials = new AWS.CognitoIdentityCredentials({
							IdentityPoolId: "us-east-1:b872b759-d2c9-4347-b8dc-ec18ec82af83"
						});
						credentials.get(function(err) {
							var stage = swurveysStageConfig.getConfigPropertyValue("api_endpoint").split("/").pop();
							var topic = stage + "/users/" + userId + "/swurveys/" + id + "/model";
							liveReloadService.init(credentials, userId+new Date().getTime(), topic, function(msg) {
								var newModel = msg.payload;

								reloadStyles(newModel.billboard.styles);
							});
						});

						$("#sk-messenger-button").hide();
						$(".pace").hide();
					}



					//Extract Swurvey name
					$scope.swurveName = model.name;

					console.log("Card Map:");
					console.log($scope.cards);

					//Retrieve analytics data (JSON format)
					getJSON(id);
					autoReloadInterval = $interval(function(){getJSON(id);}, 5000);

				});
			};

			swurveID = $routeParams.sid;
			//Check for swurvey id param
			if (!swurveID) {
				var uid = credential.swurveys.identityId();
				utilsService.gotoDashboard(uid);
			} else {
				loadSwurvey(swurveID);
				$scope.publicURL = $location.absUrl().replace('private', 'public');
			}

			/**
			 * Retrieves the analytics data (JSON format) for a given ID
			 * @param id Swurvey ID
			 */
			var getJSON = function (id) {
				var url;
				//If user is logged in, use the auth endpoint
				//For the standard analytics pages, the navbar will force login
    			if(credential.isLoggedIn())
				{
				  url = swurveyAdminService.getJSONLink(id);
				}
				else
				{
				  //else, use the unauth'd endpoint.
				  //This endpoint only works if the billboard is enabled OR 'See All Results' is enabled
				  url = utilsService.getNoAuthResponsesLink(id);
				}

				$http.get(url)
					.then(function (response) {

						var responses = {};
						if(response.data)
						{
							//We got data back

							$scope.totalAttempted = response.data.TotalAttemptedCount || 0;

							$scope.totalResponses = response.data.TotalResponseCount || 0;

							responses = response.data.Responses;
						}
						else{
							$scope.totalAttempted = 0;
							$scope.totalResponses = 0;
							responses = utilsService.generateBlankResponse($scope.model);
						}

						for (var card_id in responses) {
							var response = responses[card_id];
							generateData(response, card_id);

						}
						updateDataView();

					}, function (err) {
						console.error(err);
					});
			};

			/**
			 * Updates charts object by combining the Swurvey model data with the analytics data
			 * @param response JSON object containing analytics info
			 * @param card_id ID of the card being evaluated
			 */
			var generateData = function (response, card_id) {

				var labels = [];
				var data = [];
				var rawData = [];
				var allData = [];
				var cardModel = $scope.cards[card_id];


				//Helper to order things in 'definition order'
				var dnMap = {
					left : 1,
					one : 1,
					two : 2,
					bottom : 2,
					top : 2,
					right : 3,
					three : 3,
					four : 4,
					five : 5
				}
				for(var direction in response) {

					var keyName = cardModel[direction].choice.toString();
					var entry = {
						'label': keyName,
						'rawData': response[direction], //This will always be the raw data
						'data': response[direction], //This will change to percent or raw data
						direction: direction
					};
					allData.push(entry);
				}

				var sortMode = $routeParams.sortMode;
				switch (sortMode) {
					case "asDefined":
						allData.sort(function(a, b) {
							if (dnMap[a.direction] > dnMap[b.direction]) {
								return 1;
							}
							if (dnMap[a.direction] < dnMap[b.direction]) {
								return -1;
							}
							// a must be equal to b
							return 0;
						});
					  break;
					case "minmax":
					default:
						//Sort dataset from min to max. This is the default
						allData.sort(function (a, b) {
							if (a.data > b.data) {
								return 1;
							}
							if (a.data < b.data) {
								return -1;
							}
							// a must be equal to b
							return 0;
						});
				}

				//Move data into arrays
				for(var x = 0; x < allData.length; x++) {
					labels.push(allData[x].label);
					data.push(allData[x].data);
					rawData.push(allData[x].rawData);
				}

				//Add Analytics data to card
				var card = $scope.cards[card_id];

				card.data = data;
				card.rawData = rawData;
				card.labels = labels;

				card.topAnswerDataRaw = card.data[card.data.length - 1];
				card.topAnswerText = card.labels[card.data.length - 1];

			};

			/**
			 * Converts a pie chart into a bar chart
			 * @param id Card ID from the cards object
			 */
			$scope.changeToBar = function (card) {
				card.chartType = "bar";
			};

			/**
			 * Converts a bar chart into a pie chart
			 * @param id Card ID from the cards object
			 */
			$scope.changeToPie = function (card) {
				card.chartType = "pie";
			};

			/**
			 * Displays analytics data in CSV format via new tab
			 */
			$scope.CSV = function (swurveyId, partition) {
				var eventName = 'DownloadCSV';
				if(partition)
				{
					eventName = eventName + "-" + partition;
				}
				analyticsService.trackEvent(eventName, swurveID);
				var url = swurveyAdminService.getCSVLink(swurveID, partition);
				console.log(url);
				$window.open(url, "_blank");
			};

			/**
			 * Social Share
			 */

			 $scope.fbShare = function () {

				analyticsService.trackEvent('ShareClick-Facebook', swurveID);

		 		var fbAppId = credential.facebook.app_id;

		 		var shareLink =
		 			"https://www.facebook.com/dialog/share?app_id=" + fbAppId + "&display=page&href=" +
		 			encodeURI($scope.url) +
		 			"&redirect_uri=https%3A%2F%2Fapp.swurveys.com%2Fdesigner.html";

				$window.location.href = shareLink;
		 	};

		 	$scope.twitterShare = function () {

				analyticsService.trackEvent('ShareClick-Twitter', swurveID);

		 		var twitterLink = "https://twitter.com/intent/tweet?text=" + "Check out this cool Swurvey:%20&url=" + encodeURI($scope.url);
		 		$window.location.href = twitterLink;
		 	}

		 	$scope.googleShare = function () {

				analyticsService.trackEvent('ShareClick-Google', swurveID);

		 		var shareLink = 'https://plus.google.com/share?url=' + encodeURI($scope.url);

				$window.location.href = shareLink;
		 	}

		 	$scope.mailShare = function () {

				analyticsService.trackEvent('ShareClick-Email', swurveID);

		 		var shortUrl = $scope.url;

		 		var shareLink = "mailto:?subject=" + encodeURI("Check Out This Swurvey") + "&body=" + shortUrl;

		 		$window.location.href = shareLink;
		 	}

		 	$scope.smsShare = function () {

				analyticsService.trackEvent('ShareClick-SMS', swurveID);

		 		var shortUrl = $scope.url;

		 		var shareLink = "sms:?&body=" + encodeURI("Check Out This Swurvey : " + shortUrl);

		 		$window.location.href = shareLink;
		 	};

			/**
			 * Converts the number of submissions for a single answer to a percentage
			 * @param answers Number of submissions for a given answer
			 * @param total   Total number of submissions
			 * @returns {number}  Percentage (double)
			 */
			var getAsPercent = function (answers, total) {
				var num = (answers / total) * 100;
				return +(Math.round(num + "e+2") + "e-2") || 0;
			};

			/**
			 * Converts the number of submissions for a single answer to a raw number
			 * @param answers Number of submissions for a given answer
			 * @param total   Total number of submissions
			 * @returns {number}  Number (double)
			 */
			var getAsRawNumber = function (percent, total) {
				var num = (percent * total) / 100;
				return +(Math.round(num + "e+2") + "e-2");
			};

		    $scope.$on("$locationChangeStart", function (event) {
		    	$interval.cancel(autoReloadInterval);
		    });

		}

}());
